/* eslint-disable no-undef */
import React from 'react';
import ReactDOM from 'react-dom';
import ObjectiveKeyResults from './people/components/ObjectiveKeyResults';
import ObjectiveEditDelete from './people/components/ObjectiveEditDelete';
import Sidebar from './common/layout/Sidebar';
import Header from './common/layout/Header';
import PageHeader from './common/layout/PageHeader';
import { PeopleNavItems, PeopleSearch, PeopleUserNavItems } from './people/layout/PeopleLayout';
import Notes from './common/components/Notes';
import PeopleApp from './people/PeopleApp';
import LeaveAllowance from './people/components/LeaveAllowance';
import ArchivedObjectives from './people/components/ArchivedObjectives';
import SicknessPdf from './people/components/SicknessPdf';
import UserProfileFunFact from './people/pages/UserProfileFunFact';
import { UserProfileTabs } from './people/pages/UserProfilePage';
import { initAppSentry } from './common/sentry';

initAppSentry();

const peopleAppElement = document.getElementById('g4m-people-app');

if (peopleAppElement) {
  ReactDOM.render(<PeopleApp {...window.props} />, peopleAppElement);
}

const keyResultsElement = document.getElementById('objective-key-results');

if (keyResultsElement) {
  const objectiveId = keyResultsElement.getAttribute('data-objective');
  const edit = keyResultsElement.getAttribute('data-edit');
  ReactDOM.render(<ObjectiveKeyResults objective={objectiveId} edit={edit} />, keyResultsElement);
}

const deleteObjectiveElement = document.getElementById('edit-objective-delete-wrap');
if (deleteObjectiveElement) {
  const objectiveId = deleteObjectiveElement.getAttribute('data-objective-id');
  const urlUserObjectives = deleteObjectiveElement.getAttribute('data-url-user-objectives');
  ReactDOM.render(
    <ObjectiveEditDelete
      objectiveId={objectiveId}
      urlUserObjectives={urlUserObjectives}
    />,
    deleteObjectiveElement,
  );
}

const sidebarElement = document.getElementById('sidebar');

if (sidebarElement) {
  const sidebarComponent = (
    <Sidebar
      {...window.props}
      navItems={<PeopleNavItems {...window.props} />}
      userNavItems={<PeopleUserNavItems {...window.props} />}
    />
  );

  ReactDOM.render(sidebarComponent, sidebarElement);
}

const appHeaderElement = document.getElementById('app-header');

if (appHeaderElement) {
  const headerComponent = (
    <Header search={<PeopleSearch {...window.props} />} {...window.props} />
  );

  ReactDOM.render(headerComponent, appHeaderElement);
}

const pageHeaderElement = document.getElementById('page-header');

if (pageHeaderElement) {
  ReactDOM.render(<PageHeader {...window.props} />, pageHeaderElement);
}

const notesElement = document.getElementById('legacy-notes');

if (notesElement) {
  const sessionUserAttr = notesElement.getAttribute('data-session-user');
  const relatedUserAttr = notesElement.getAttribute('data-related-user');

  const sessionUser = sessionUserAttr ? JSON.parse(sessionUserAttr) : null;
  const relatedUser = relatedUserAttr ? JSON.parse(relatedUserAttr) : null;

  ReactDOM.render(
    <Notes
      modelId={notesElement.getAttribute('modelId')}
      modelType={notesElement.getAttribute('modelType')}
      sessionUser={sessionUser}
      relatedUser={relatedUser}
    />,
    notesElement,
  );
}

const leaveAllowanceElement = document.getElementById('legacy-leave-allowance');

if (leaveAllowanceElement) {
  ReactDOM.render(<LeaveAllowance userId={leaveAllowanceElement.getAttribute('data-user')} />, leaveAllowanceElement);
}

const sicknessDownloadElement = document.getElementById('react-sickness-download-all-pdfs');

if (sicknessDownloadElement) {
  const sicknessIdsString = sicknessDownloadElement.getAttribute('data-sickness-ids');
  ReactDOM.render(<SicknessPdf sicknessIds={sicknessIdsString ? sicknessIdsString.split(',') : ''} />, sicknessDownloadElement);
}

const userTabsElement = document.getElementById('user-profile-tabs');

if (userTabsElement) {
  ReactDOM.render(
    (
      <UserProfileTabs
        user={window.props.profileUser}
        activeUser={window.props.activeUser}
        groups={window.props.groups}
      />
    ), userTabsElement,
  );
}

function updateApprover(name) {
  $('.approver-name').text(name);
}

$('#leave_type_id').on('change', function () {
  const $type = $(this).find('option:selected');
  updateApprover($type.data('approver'));
});

$('.leave-date-selector').on('change', () => {
  if ($('#start_date').val() === $('#end_date').val()) {
    $('.duration-type').slideDown();
  } else {
    $('.duration-type').slideUp();
  }
});

$('.leave-date-selector').on('change', () => {
  $.get('/leave/inline-help', {
    start_date: $('#start_date').val(),
    end_date: $('#end_date').val(),
  }, (data) => {
    $('#days-help').html(data);
  });
});

$('#form-leave-create').on('submit', function () {
  $(this).find('button').prop('disabled', true);
});

$('.salary-amount').on('change', function () {
  $(this).parents('.salary-form').submit();
});

$(document).ready(() => {
  const $type = $('#leave_type_id').find('option:selected');
  updateApprover($type.data('approver'));
});

$('.form-add-objective').on('submit', function (e) {
  e.preventDefault();
  e.stopPropagation();

  const $el = $(this);
  $el.find('.btn').prop('disabled', true).html('<i class="fa fa-spin fa-cog"></i>');

  $.post($(this).attr('action'), $(this).serialize(), (data) => {
    $el.find('.btn').prop('disabled', false).text('Add Objective');

    let $before = $el.parents('tbody').find('tr.text-success').first();

    if ($before.length) {
      $before.before(data);
      return;
    }

    $before = $el.parents('tbody').find('tr.objective-form');
    $before.before(data);

    $el.find('input[name="description"]').val('');
  });

  return false;
});

$('[data-toggle="tooltip"]').tooltip();

function updateReviewTips() {
  const guidance = {
    1: { title: 'Struggling in this area', desc: 'This is an area that needs work, may be underperforming here or finding it difficult to meet the expected level.' },
    2: { title: 'Getting better', desc: 'Working on this area, but still more to do. May have just started a new role and working up to the expected level. This is a good thing to work on over the next year.' },
    3: { title: 'Doing well', desc: 'Meeting our high standards in this area. This is where we expect most people to be. Completely, utterly able to accomplish what is needed.' },
    4: { title: 'Exceeding expectations', desc: 'Doing more than expected by the team, even at our high level. Does and teaches. Exceptional and noticeable skills. Goes over and above what is expected of them.' },
    5: { title: 'Outstanding', desc: "Consistently exceptional. Regularly goes above and beyond. Even in our amazing team, we'd only expect one person to achieve this rating." },
  };

  $('#user-review .score').each(function () {
    const score = $(this).find('select').val();
    $(this).find('.guidance span').text(guidance[score].desc);
  });
}

updateReviewTips();

$('.score-select').on('change', updateReviewTips);

$('.btn-continue').on('click', function (e) {
  e.stopPropagation();
  e.preventDefault();

  const toTarget = $(this).data('target');
  const toCheck = $(this).data('check');

  if (typeof toCheck !== 'undefined' && toCheck.length) {
    const checkVal = $(`#${toCheck}`).val().toLowerCase();

    if (checkVal === '' || checkVal === 'no' || checkVal === 'n/a') {
      $(`#${toCheck}`).addClass('is-invalid');
      return;
    }

    $(`#${toCheck}`).removeClass('is-invalid');
  }

  const $header = $(this).parents('.card').find('.card-header');

  if ($header.find('.fa').length === 0) {
    $header.prepend('<i class="fa fa-check-circle text-success mr-2"></i>');
  }

  $(toTarget).collapse('show');
});

const viewArchivedObjectivesElement = document.getElementById('view-archived-objectives');
if (viewArchivedObjectivesElement) {
  ReactDOM.render(<ArchivedObjectives {...window.props} />, viewArchivedObjectivesElement);
}

const profileFunFactElement = document.getElementsByClassName('fun-fact-container');
if (profileFunFactElement.length) {
  ReactDOM.render(<UserProfileFunFact {...window.props} />, profileFunFactElement[0]);
}
